module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-kpito-01@2x.e25c23b7.jpg";